import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import { ReviseGuestForm } from "./components/ReviseGuestForm";
import Moment from "react-moment";
import "moment-timezone";
import { fetchRsvp } from "../../utils/api/helpers/rsvp";
import { cancelRsvp } from "../../utils/api/helpers/rsvp";
import { reviseRsvp } from "../../utils/api/helpers/rsvp";

const UpdateRSVP = () => {
  const { hash } = useParams();

  const [loadError, setLoadError] = useState(null);
  const [actionError, setActionError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const [formSubmitted, setFormSubmitted] = useState(false),
    [formIsValid, setFormIsValid] = useState(true),
    [loaded, setLoaded] = useState(false),
    [rsvp_status, setRsvpStatus] = useState(null),
    [showModal, setShowModal] = useState(false),
    // [logoImageSrc, setLogoImageSrc] = useState(null),
    [allowGuests, setAllowGuests] = useState(false),
    [encEmail, setEncEmail] = useState(null),
    [name, setName] = useState(""),
    [guild_affiliation_id, setGuildAffiliationId] = useState(null),
    [guild_affiliation_name, setGuildAffiliationName] = useState(null),
    [guestList, setGuestList] = useState([]),
    [guestThreshold, setGuestThreshold] = useState(0),
    [cancelled, setCancelled] = useState(null),
    [emailDisabled, setEmailDisabled] = useState(null),
    [startDate, setStartDate] = useState(null),
    [startTime, setStartTime] = useState(null),
    [timeZone, setTimeZone] = useState(null),
    [eventTitle, setEventTitle] = useState(""),
    // [eventDescription, setEventDescription] = useState(""),
    [venueName, setVenueName] = useState(""),
    [venueAddress, setVenueAddress] = useState(""),
    [totalRSVPs, setTotalRSVPs] = useState(0),
    [totalThreshold, setTotalThreshold] = useState(0);
  // [eventShows, setEventShows] = useState([]);

  const person = () => {
    return {
      name: name.trim(),
      emailBytes: encEmail,
      ref_hash: hash,
      guild_id: guild_affiliation_id,
      guests: guestList.filter((guest) => guest?.name?.trim() !== ""),
    };
  };

  useEffect(() => {
    let active = true;

    window.scrollTo({ left: 0, top: 0, behavior: "auto" });
    setFormIsValid(true);
    setLoadError(null);
    setActionError(null);
    setSuccessMessage(null);
    setFormSubmitted(false);
    setLoaded(false);

    fetchRsvp(hash)
      .then((result) => {
        if (!active || !result || !result.data || !result.data.rsvp) return;

        const { rsvp, guests } = result.data;

        setLoaded(true);
        setEncEmail(rsvp.emailBytes?.data || null);
        setName(rsvp.name || "");
        setRsvpStatus("CONFIRMED");
        // setLogoImageSrc(fyseePlaceholder);
        setAllowGuests(Boolean(rsvp.allow_guests));
        setGuestList(Array.isArray(guests) ? guests : []);
        setGuestThreshold(Number(rsvp.guest_threshold) || 0);
        setGuildAffiliationName(rsvp.guildName || null);
        setGuildAffiliationId(rsvp.guildId || null);
        setCancelled(rsvp.cancelled);
        setEmailDisabled(rsvp.email_disabled);

        if (rsvp.start_date) {
          const tempDateTime = `${rsvp.start_date.split("T")[0]}T12:00:00.000`;
          setStartDate(tempDateTime);
        } else {
          setStartDate(null);
        }

        if (rsvp.start_time) {
          const hours = `${rsvp.start_time.split(":")[0]}:${
            rsvp.start_time.split(":")[1]
          }`;
          setStartTime(tConvert(hours));
        } else {
          setStartTime(null);
        }

        setTimeZone(rsvp.timezone || null);
        setEventTitle(rsvp.event_title || "");
        // setEventDescription(rsvp.event_description);
        setVenueName(rsvp.venueName || "");
        setVenueAddress(rsvp.venueAddress || "");
        setTotalRSVPs(Number(rsvp.total_rsvps) || 0);
        setTotalThreshold(Number(rsvp.total_threshold) || 0);
        // setVenueId(rsvp.venue_id)
        // setEventShows(result.data.shows);
      })
      .catch(() => {
        if (!active) return;
        setLoaded(true);
        setLoadError(
          "We were unable to load your RSVP details at this time. Please try again later.",
        );
      });

    return () => {
      active = false;
    };
  }, [hash]);

  const tConvert = (time) => {
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      time = time.slice(1);
      time[5] = +time[0] < 12 ? " AM" : " PM";
      time[0] = +time[0] % 12 || 12;
    }

    return time.join("");
  };

  const validateForm = () => {
    const isValid = name.trim() !== "";
    setFormIsValid(isValid);
    return isValid;
  };

  const updateRsvp = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      setShowModal(false);
      return;
    }

    setShowModal(false);
    setActionError(null);
    setSuccessMessage(null);

    let handled = false;

    const handleSuccess = () => {
      if (handled) return;
      handled = true;
      setFormSubmitted(true);
      setRsvpStatus(null);
      setSuccessMessage("Your RSVP has been successfully updated.");
    };

    const handleError = () => {
      if (handled) return;
      handled = true;
      setFormSubmitted(false);
      setActionError(
        "We were unable to update your RSVP at this time. Please try again later.",
      );
    };

    try {
      const result = reviseRsvp(hash, person(), handleSuccess);

      if (result && typeof result.then === "function") {
        result.then(handleSuccess).catch(handleError);
      }
    } catch {
      handleError();
    }
  };

  const cancel = () => {
    setCancelled(true);
    setActionError(null);

    const result = cancelRsvp(hash);

    if (result && typeof result.catch === "function") {
      result.catch(() => {
        setCancelled(false);
        setActionError(
          "We were unable to cancel your RSVP at this time. Please try again later.",
        );
      });
    }
  };

  const updateGuestList = (idx, guest, remove) => {
    setGuestList((prevGuestList) => {
      if (remove) {
        return prevGuestList.filter((el) => el.name !== guest.name);
      }

      const nextGuestList = prevGuestList.slice();

      if (idx < 0) {
        nextGuestList.push(guest);
      } else {
        nextGuestList[idx] = guest;
      }

      return nextGuestList;
    });
  };

  const openReviewModal = () => {
    const filteredGuests = guestList.filter(
      (guest) => guest?.name?.trim() !== "",
    );

    if (filteredGuests.length !== guestList.length) {
      setGuestList(filteredGuests);
    }

    if (!validateForm()) {
      return;
    }

    setShowModal(true);
  };

  const hasGuests =
    Array.isArray(guestList) &&
    guestList.length > 0 &&
    guestList.some((guest) => guest?.name?.trim());

  const filledGuestCount = guestList.filter(
    (guest) => guest?.name?.trim() !== "",
  ).length;

  const currentGuestRows = Array.isArray(guestList) ? guestList.length : 0;

  const guestThresholdReached = currentGuestRows >= guestThreshold;
  const eventCapacityReached = totalRSVPs >= totalThreshold;

  const canAddGuests =
    allowGuests &&
    guestThreshold > 0 &&
    !guestThresholdReached &&
    !eventCapacityReached;

  return (
    <>
      <div
        className="page__container mx-auto my-5 pt-5 px-4 position-relative z-1"
        style={{ maxWidth: 1200 }}
      >
        <div className="width_ctrl fw-bold text-dark">
          {loaded ? (
            loadError ? (
              <div
                className="text-center my-5 col-12 col-lg-8 mx-auto lh-sm"
                role="alert"
                aria-live="polite"
              >
                {loadError}
              </div>
            ) : (
              <div data-rsvp-status={rsvp_status}>
                {!cancelled ? (
                  <div className="">
                    {Number(emailDisabled) === 0 ? (
                      <>
                        <div className="d-flex flex-column align-items-center border border-black border-4">
                          <div className="d-flex flex-column align-items-center gap-3 w-100 bg-black pb-2">
                            <h1 className="nf-sans-cond my-0 fw-bold text-center text-white">
                              Update Your RSVP
                            </h1>
                          </div>

                          <div
                            className={
                              "d-flex row w-100 flex-column flex-md-row"
                            }
                          >
                            <div
                              className="col-12 col-md-4 d-flex flex-column p-4 border-md-end-4 fw-bold"
                              aria-label="Event details"
                            >
                              <div className="h1 fw-bold nf-sans-cond event__excerpt--title">
                                {eventTitle}
                              </div>

                              <div className="d-flex flex-column gap-2">
                                {startDate ? (
                                  <div className="fw-bold">
                                    <Moment format="dddd MMMM D, YYYY">
                                      {startDate}
                                    </Moment>{" "}
                                    @ {startTime}
                                    &nbsp;
                                    {timeZone}
                                  </div>
                                ) : (
                                  ""
                                )}

                                <div>
                                  {venueName} - {venueAddress}
                                </div>
                              </div>
                            </div>

                            <div className="col-12 col-md-8 p-4">
                              {actionError ? (
                                <div
                                  className="mb-4"
                                  role="alert"
                                  aria-live="polite"
                                >
                                  {actionError}
                                </div>
                              ) : null}

                              {!formSubmitted ? (
                                <>
                                  <div className="lh-sm mb-4 fw-bold">
                                    If you wish to update your RSVP, you may
                                    change your name and/or guest(s) by editing
                                    the form below.
                                  </div>

                                  <Form
                                    noValidate
                                    aria-label="Update RSVP form"
                                    className="d-flex flex-column gap-4"
                                    onSubmit={(e) => {
                                      e.preventDefault();
                                      openReviewModal();
                                    }}
                                  >
                                    <div className="d-flex flex-column">
                                      <h4 className="nf-sans-cond pb-2 m-0 text-uppercase fw-bold text-dark">
                                        <label htmlFor="signup_name">
                                          NAME:
                                        </label>
                                      </h4>

                                      <Row className="">
                                        <Col lg={12}>
                                          <Form.Group controlId="signup_name">
                                            <Form.Control
                                              className=""
                                              value={name}
                                              required
                                              aria-required="true"
                                              aria-invalid={
                                                !formIsValid &&
                                                name.trim() === ""
                                              }
                                              onChange={(e) => {
                                                setName(e.target.value);
                                                if (
                                                  !formIsValid &&
                                                  e.target.value.trim() !== ""
                                                ) {
                                                  setFormIsValid(true);
                                                }
                                              }}
                                              placeholder="Name"
                                            />
                                          </Form.Group>
                                          {!formIsValid &&
                                          name.trim() === "" ? (
                                            <div
                                              className="validation__message"
                                              role="alert"
                                              aria-live="polite"
                                            >
                                              Please enter a Name
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </Col>
                                      </Row>
                                    </div>

                                    <div className="">
                                      <h4 className="nf-sans-cond fw-bold text-dark m-0">
                                        Guild Affiliation:{" "}
                                        {guild_affiliation_name
                                          ? guild_affiliation_name
                                          : "None Selected"}
                                      </h4>
                                    </div>

                                    <div className="d-flex flex-column">
                                      <div className="d-flex w-100 align-items-center ">
                                        <h4 className="nf-sans-cond text-uppercase fw-bold text-dark m-0 p-0">
                                          GUESTS:
                                        </h4>
                                        <div className={"ms-auto d-flex gap-2"}>
                                          {allowGuests && guestThreshold > 0 ? (
                                            <>
                                              {!canAddGuests ? (
                                                <div
                                                  className="mt-2"
                                                  role="status"
                                                  aria-live="polite"
                                                >
                                                  {guestThresholdReached
                                                    ? "You have reached the guest limit for this RSVP."
                                                    : "Event is at capacity, no additional guests can be added."}
                                                </div>
                                              ) : null}
                                              <Button
                                                type="button"
                                                className={
                                                  "rsvp-edit-button " +
                                                  (!canAddGuests &&
                                                  !guestThresholdReached
                                                    ? "d-none"
                                                    : "")
                                                }
                                                disabled={!canAddGuests}
                                                onClick={() => {
                                                  if (!canAddGuests) return;

                                                  updateGuestList(-1, {
                                                    name: "",
                                                  });
                                                }}
                                                aria-label="Add guest"
                                              >
                                                <span className="nf-sans-cond label-small">
                                                  + Add Guest
                                                </span>
                                              </Button>
                                            </>
                                          ) : (
                                            <div>
                                              <Col lg={12}>
                                                <div className="text-center">
                                                  No guests can be added for
                                                  this event
                                                </div>
                                              </Col>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      {allowGuests && guestThreshold > 0 ? (
                                        <Row className="">
                                          <Col lg={12}>
                                            <div className="d-flex flex-column w-100">
                                              <div className="d-flex flex-column gap-3">
                                                {guestList
                                                  ? guestList.map((gl, i) => (
                                                      <ReviseGuestForm
                                                        key={i}
                                                        idx={i}
                                                        guest={gl}
                                                        updateGuest={
                                                          updateGuestList
                                                        }
                                                        formIsValid={
                                                          formIsValid
                                                        }
                                                      />
                                                    ))
                                                  : ""}
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      ) : (
                                        <></>
                                      )}
                                    </div>

                                    <Row className="justify-content-center">
                                      <Col
                                        lg={12}
                                        className="nf-sans-cond d-flex justify-content-center"
                                      >
                                        <Button
                                          type="submit"
                                          className="rsvp-edit-button rsvp-dark-button w-100"
                                        >
                                          Update my RSVP
                                        </Button>
                                      </Col>
                                    </Row>
                                  </Form>
                                </>
                              ) : (
                                <div
                                  className="text-center my-5 fw-bold"
                                  role="status"
                                  aria-live="polite"
                                >
                                  {successMessage ||
                                    "Thank you for submitting your RSVP updates!"}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="d-flex flex-column align-items-center text-center gap-3">
                        <h1 className="my-0 fw-bold text-center display-5">
                          RSVPs Closed
                        </h1>
                        <div>Changes to RSVPs for this event are closed.</div>
                      </div>
                    )}

                    {!cancelled ? (
                      <div className="d-flex flex-column align-items-center text-center mt-5 border border-black border-4">
                        <div className={"bg-black text-white w-100 pb-1"}>
                          <h1 className="nf-sans-cond my-0 fw-bold text-center">
                            Cancel Your RSVP
                          </h1>
                        </div>
                        <div className={"p-4 w-100"}>
                          <div className="lh-sm mb-4 fw-bold">
                            If you wish to cancel your RSVP, click the button
                            below. You will receive a cancellation email
                            shortly.
                          </div>

                          {actionError && !formSubmitted ? (
                            <div
                              className="mb-4"
                              role="alert"
                              aria-live="polite"
                            >
                              {actionError}
                            </div>
                          ) : null}

                          <div className="nf-sans-cond w-100 ">
                            <Button
                              type="button"
                              className="rsvp-edit-button rsvp-dark-button px-5 w-100"
                              onClick={() => {
                                cancel();
                              }}
                              aria-label="Cancel my RSVP"
                            >
                              Cancel my RSVP
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : (
                  <div className="ps-0 ps-md-5 d-flex flex-column align-items-center text-center gap-3">
                    <h1 className="my-0 fw-bold text-center display-5">
                      RSVP Cancelled
                    </h1>
                    <div>Your RSVP has been cancelled.</div>
                  </div>
                )}
              </div>
            )
          ) : (
            <div
              className="w-100 text-center p-5 opacity-50"
              role="status"
              aria-live="polite"
            >
              Loading ...
            </div>
          )}
        </div>
      </div>

      <div className="events-page-background" />
      <div className="events-page-background-gradient" />

      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        size="lg"
        dialogClassName="rsvp-review-modal"
        centered={true}
        aria-labelledby="rsvp-review-modal-title"
      >
        <Modal.Header closeButton className="bg-black border-0">
          <div
            id="rsvp-review-modal-title"
            className="fs-4 nf-sans-cond fw-bold text-uppercase"
          >
            Please review your revision
          </div>
        </Modal.Header>

        <Modal.Body className="bg-black text-white pt-0">
          <div className="p-4 bg-white bg-opacity-10 fs-5 d-flex flex-column gap-4">
            <div className={"d-flex flex-column flex-md-row w-100 gap-4"}>
              <div className={"col-12 col-md-6"}>
                <div className="nf-sans-cond fw-bold mb-1 text-uppercase">
                  Name:
                </div>
                <div className="fw-bold">{name}</div>
              </div>

              <div className={"col-12 col-md-6"}>
                {hasGuests ? (
                  <>
                    <div className="nf-sans-cond fw-bold mb-1 text-uppercase">
                      Guests:
                    </div>
                    {guestList
                      .filter((gl) => gl?.name?.trim())
                      .map((gl, i) => (
                        <div key={i} className="fw-bold mb-1">
                          {gl.name}
                        </div>
                      ))}
                  </>
                ) : (
                  <>
                    <div className="nf-sans-cond fw-bold mb-1 text-uppercase">
                      Guests:
                    </div>
                    <div className="mb-1 fw-bold">No Guests Selected</div>
                  </>
                )}
              </div>
            </div>

            <div className="d-flex flex-column gap-4 text-center">
              <Button
                type="button"
                className="w-100 rsvp-edit-button white-button px-4"
                onClick={(e) => {
                  updateRsvp(e);
                }}
              >
                Yes, submit these updates to my RSVP
              </Button>

              <Button
                type="button"
                className="w-100 rsvp-edit-button white-button px-4"
                onClick={() => {
                  setShowModal(false);
                }}
              >
                No, let me make further changes
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UpdateRSVP;
